import { useState } from 'react';
import { X } from 'lucide-react';

export function AppDownloadBanner() {
  // iPadOS can request the desktop site and identify itself as a Mac.
  // Device detection keeps narrow desktop windows from showing an iOS install prompt.
  const supportsIOSApp =
    typeof navigator !== 'undefined' &&
    (/iPhone|iPad|iPod/i.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1));
  const [dismissed, setDismissed] = useState(() => {
    try {
      return sessionStorage.getItem('ggb.app-banner-dismissed') === '1';
    } catch {
      return false;
    }
  });
  if (!supportsIOSApp || dismissed) return null;
  return (
    <aside className="app-download-banner elevation-1" aria-label="Garage Gym Bros for iOS">
      <button
        type="button"
        className="icon-button"
        aria-label="Dismiss app notification"
        onClick={() => {
          setDismissed(true);
          try {
            sessionStorage.setItem('ggb.app-banner-dismissed', '1');
          } catch {
            /* optional preference */
          }
        }}
      >
        <X size={14} />
      </button>
      <img src="/apple-touch-icon.png" width="40" height="40" alt="" />
      <span>
        <strong>Garage Gym Bros</strong>
        <small>Built at home. Never alone.</small>
      </span>
      <a className="text-link" href="https://apps.apple.com/app/id6828416149">
        Get the app
      </a>
    </aside>
  );
}
